/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

const ToastsList = styled.div`
  ${({ theme }) => css`
    width: fit-content;
    max-width: 570px;

    display: flex;
    flex-direction: column-reverse;

    position: fixed;
    bottom: 42px;
    left: 42px;
    z-index: ${theme.zIndex.toast};
    gap: ${theme.spacing.km2};

    @media screen and (max-width: ${theme.breakpoint.sm.maxWidth}) {
      max-width: 100%;
      padding-right: ${theme.spacing.km4};
    }
  `}
`;

export { ToastsList };
